import { useCallback, useEffect, useMemo, useState } from 'react';

function getInitialTheme() {
  if (typeof window === 'undefined') return 'light';
  const savedTheme = localStorage.getItem('theme_mode');
  if (savedTheme && savedTheme !== 'device') return savedTheme;
  // Check system preference
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
}

export default function useTheme() {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    localStorage.setItem('theme_mode', theme);
    document.body.setAttribute('data-theme', theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  }, []);

  return useMemo(() => ({ theme, setTheme, toggleTheme }), [theme, toggleTheme]);
}
